module.exports = __webpack_public_path__ + "static/media/logo_sansfond.6db6e15e.svg";